import { createContext, useContext, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const TransitionContext = createContext(null);

export function usePageTransition() {
  return useContext(TransitionContext);
}

export function TransitionProvider({ children }) {
  const navigate  = useNavigate();
  const [active, setActive] = useState(false);
  const busy = useRef(false);

  const navigateTo = useCallback((path) => {
    if (busy.current) return;
    busy.current = true;

    setActive(true);                        // fade overlay in

    setTimeout(() => {
      navigate(path);                       // switch route while hidden
      setTimeout(() => {
        setActive(false);                   // fade overlay out over new page
        busy.current = false;
      }, 60);
    }, 420);                                // match CSS transition duration
  }, [navigate]);

  return (
    <TransitionContext.Provider value={navigateTo}>
      {children}
      <div className={`page-fade-overlay${active ? ' active' : ''}`} aria-hidden="true" />
    </TransitionContext.Provider>
  );
}
